'use client';

import classnames from 'classnames';
import { usePathname } from 'next/navigation';
import React from 'react';
import Link from 'next/link';
import styles from './CareerTabs.module.scss';

type CareerTabsProps = {
  className?: string,
};
const CareerTabs = ({ className }: CareerTabsProps) => {
  const pathname = usePathname();
  return (
    <nav className={classnames(styles.tabs, className)}>
      <Link
        className={classnames(styles.tab, {
          [styles.active]: pathname.includes('vacancies'),
        })}
        href='/career/vacancies'
      >
        Vacancies
      </Link>
      <Link
        href='/career/education'
        className={classnames(styles.tab, {
          [styles.active]: pathname.includes('education'),
        })}
      >
        Education
      </Link>
    </nav>
  );
};

export default CareerTabs;
